import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import AdvancedCarePolicyPage from "@/containers/PublicPages/AdvancedCarePolicyPage";
import { DashboardRouter } from "@/containers/Dashboard/DashboardRouter";
import HipaaPolicyPage from "@/containers/PublicPages/HipaaPolicyPage";
import PricingPage from "@/containers/PublicPages/PricingPage";
import PrivacyPolicy from "@/components/Common/PrivacyPolicy";
import PrivacyPolicyPage from "@/containers/PublicPages/PrivacyPolicyPage";
import RedirectSplashScreen from "@/redirectSplashScreen";
import TermsAndConditionsPolicyPage from "@/containers/PublicPages/TermsAndConditionsPolicyPage";
import TreatmentPolicyPage from "@/containers/PublicPages/TreatmentPolicyPage";
import Unsubscribe from "@/components/Common/Unsubscribe";

export const getAuthenticatedRoutes = (props) => (
  <Switch>
    <Route
      path={props.auth.authRedirectPath}
      render={(compProps) => <DashboardRouter {...compProps} role={props.auth.role} />}
    />

    <Route
      component={(compProps) => (
        <RedirectSplashScreen {...compProps} redirectPath={props.auth.authRedirectPath} />
      )}
      path="/redirect"
    />

    <Route component={AdvancedCarePolicyPage} path="/advanced-care" />
    <Route component={HipaaPolicyPage} path="/hipaaprivacy" />
    <Route component={PricingPage} path="/session-pricing" />
    <Route component={PrivacyPolicyPage} path="/privacy" />
    <Route component={TermsAndConditionsPolicyPage} path="/terms-and-conditions" />
    <Route component={TreatmentPolicyPage} path="/consent" />
    <Route component={Unsubscribe} path="/unsubscribe" />
    <Route component={PrivacyPolicy} path="/privacy-policy" />

    <Redirect from="/auth" to={props.auth.authRedirectPath} />
    <Redirect to="/redirect" />
  </Switch>
);
